<template>
  <div class="">
    <v-btn class="map-content__close-button" dark icon @click="onClose">
      <v-icon large>mdi-close</v-icon>
    </v-btn>
    <naver-maps
      :height="deviceHeight"
      :width="deviceWidth"
      :mapOptions="mapOptions"
      :initLayers="['BACKGROUND', 'BACKGROUND_DETAIL', 'POI_KOREAN', 'TRANSIT']"
      @load="onLoad"
      class="map__content"
    >
    </naver-maps>
  </div>
</template>

<script>
export default {
  name: 'MapStation',
  props: {
    locationData: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      map: null,
      marker: null,
      mapOptions: {
        lat: 37.4788755,
        lng: 127.1271389,
        zoom: 14,
        zoomControl: true,
        zoomControlOptions: { position: 'TOP_LEFT' }
      }
    }
  },
  watch: {
    locationData: {
      deep: true,
      handler (value) {
        this.moveAndPin()
      }
    }
  },
  computed: {
    deviceHeight () {
      return window.innerHeight / 10 * 8
    },
    deviceWidth () {
      return window.innerWidth / 10 * 9
    }
  },
  methods: {
    onLoad (vue) {
      // 시작 포지션
      this.map = vue.map
      this.moveAndPin()
    },
    moveAndPin () {
      if (this.marker) {
        this.marker.setMap(null)
      }
      if (this.locationData) {
        const point = new window.naver.maps.LatLng(this.locationData.lat, this.locationData.lng)
        this.map.morph(point, 17, { duration: 0 })
        this.marker = new window.naver.maps.Marker({
          map: this.map,
          position: point
        })
      }
    },
    onClose () {
      this.$emit('closeModal')
    }
  }
}
</script>

<style scoped lang="scss">
.map-content {
  width: 100%;
  height: 100%;
  &__close-button {
    position: absolute;
    right: 7px;
    top: 14px;
    color: #fff;
  }
  &__set-button {
    position: absolute;
    top: 14px;
    right: 80px;
  }
}
  .map__content {
    margin: 0 auto;
  }
</style>
